<style lang="scss">
.ex-alert {
  position: fixed;
  z-index: 99999;
  bottom: 24px;
  right: 80px;
  font-size: 12px;
  padding: 20px 30px;
  border-radius: 8px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  &.error {
    background-color: #ff0000;
  }
  &.success {
    background-color: #0da313;
  }
  &.warning {
    background-color: #fd7e14;
  }
  i {
    margin-right: 10px;
    color: #ffffff !important;
  }
  span {
    font-weight: bold;
    color: #ffffff;
    text-transform: uppercase;
  }
}
</style>
<template>
  <div v-if="!mobiTablet">
    <div
      :style="{ right: `${right}px`}"
      class="ex-alert text-center"
      :class="{ error: error, success: success, warning: warning }"
      v-if="message"
    >
      <v-icon v-if="error">error</v-icon>
      <v-icon v-if="success">check</v-icon>
      <span  v-if="message !== 'ERROR'">{{ message }}</span>
      <span  v-if="message == 'ERROR'">{{ $t('ERROR') }}</span> <br> 
      <span v-if="message == 'ERROR'">{{res.processId}}</span>
    </div>
  </div>
  <div v-else>
    <v-alert
      v-if="message"
      dense
      :type="success ? 'success' : warning ? 'warning' : 'error'"
      class="alert-custom"
    >
    <span class="fs-10">{{message}}</span>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  },
  data() {
    return {
      right: 40
    };
  },
  watch: {
    message(value) {
      if (value)
        setTimeout(() => {
          let data = { message: "" };
          this.$store.commit("alert/display", data);
        }, 5000);
    }
  },
  computed: {
    message(value) {
      return this.$store.state.alert.message;
    },
    error() {
      return this.$store.state.alert.error;
    },
    success() {
      return this.$store.state.alert.success;
    },
    warning() {
      return this.$store.state.alert.warning;
    },
     res() {
      return this.$store.state.alert.res;
    }
  },
  created() {
    if (window.location.pathname == "/register") {
      this.right = 128;
    }
  }
};
</script>
